import axios from "axios";
import { useQuery } from "react-query";

// Clubs are public — no auth required to browse them.

const getClubs = async (country = "") => {
  const response = await axios.get("/api/v1/public/clubs", {
    params: country ? { country } : {},
  });
  return response.data; // { success, count, data: [...] }
};

export const useClubs = (country = "") => {
  return useQuery(["clubs", country], () => getClubs(country), {
    keepPreviousData: true,
  });
};

const getClub = async (idOrSlug) => {
  const response = await axios.get(`/api/v1/public/clubs/${idOrSlug}`);
  return response.data; // { success, data: { ...club, courts } }
};

export const useClub = (idOrSlug) => {
  return useQuery(["club", idOrSlug], () => getClub(idOrSlug), {
    enabled: Boolean(idOrSlug),
  });
};
